<lgb-header-gradient [height]="((page())? 200 : 100)" [background]="page()==null"></lgb-header-gradient>
<div class="screen-container gradient" [loading]="loading()">
	@if(page()){
		<div class="hero-card rounded-box">
			<img wSkeleton="100%" hSkeleton="500px" class="img-card" [src]="binderS.getImgPage(page(), scan())"/>
		</div>
	}
	<lgb-cta-share></lgb-cta-share>
</div>
